import { ProductState, ProductSaleType, ProductType, TrackingMode } from '@tcr-erp/shared';

export const PRODUCT_STATE_LABEL: Record<number, string> = {
  [ProductState.ACTIVE]: 'Hiển thị',
  [ProductState.DRAFT]: 'Nháp',
  [ProductState.INACTIVE]: 'Ẩn',
};

export const PRODUCT_STATE_COLOR: Record<number, string> = {
  [ProductState.ACTIVE]: 'green',
  [ProductState.DRAFT]: 'gold',
  [ProductState.INACTIVE]: 'red',
};

export const PRODUCT_STATE_BADGE_STATUS: Record<number, 'success' | 'warning' | 'error' | 'default'> = {
  [ProductState.ACTIVE]: 'success',
  [ProductState.DRAFT]: 'warning',
  [ProductState.INACTIVE]: 'error',
};

export const PRODUCT_STATE_OPTIONS = [
  { value: ProductState.ACTIVE, label: PRODUCT_STATE_LABEL[ProductState.ACTIVE] },
  { value: ProductState.DRAFT, label: PRODUCT_STATE_LABEL[ProductState.DRAFT] },
  { value: ProductState.INACTIVE, label: PRODUCT_STATE_LABEL[ProductState.INACTIVE] },
];

export const SALE_TYPE_LABEL: Record<string, string> = {
  [ProductSaleType.ONLINE]: 'Online',
  [ProductSaleType.STORE]: 'Tại chi nhánh',
};

export const PRODUCT_TYPE_LABEL: Record<string, string> = {
  [ProductType.MEDICINE]: 'Thuốc',
  [ProductType.FUNCTIONAL_FOOD]: 'Thực phẩm chức năng',
  [ProductType.OTHER]: 'Khác',
};

export const TRACKING_MODE_LABEL: Record<string, string> = {
  [TrackingMode.SERIAL]: 'Theo serial',
  [TrackingMode.QUANTITY]: 'Theo số lượng',
};

export const product_type_options = Object.values(ProductType).map((v) => ({
  value: v,
  label: PRODUCT_TYPE_LABEL[v] ?? String(v),
}));

export const sale_type_options = Object.values(ProductSaleType).map((v) => ({
  value: v,
  label: SALE_TYPE_LABEL[v] ?? String(v),
}));

export const tracking_mode_options = Object.values(TrackingMode).map((v) => ({
  value: v,
  label: TRACKING_MODE_LABEL[v] ?? String(v),
}));
